
export const isRequired = fieldName => `${fieldName} is required`;

export const mustMatch = otherFieldName => {
  return (fieldName) => `${fieldName} must match ${otherFieldName}`;
};

export const minLength = length => {
  return (fieldName) => `${fieldName} must be at least ${length} characters`;
};

export const minValue = minValue => {
  return (fieldName) => `${fieldName} must be >= ${minValue}`;
};

export const maxValue = maxValue => {
  return (fieldName) => `${fieldName} must be <= ${maxValue}`;
};

export const isPositiveInt = fieldName => `${fieldName} must be positive integer`;

export const isURL = fieldName => `${fieldName} must be valid URL`;
